import { Tag } from 'antd';
// helpers
import dayjs from 'dayjs'
import get from 'lodash/get'
import isEmpty from 'lodash/isEmpty'

const colors = ['red', 'green']
const statuses = ['Inactivo', 'Activo']

const StatusCell: React.FC = (status: boolean, record) => {

  if (!record?.id) return null

  const color = colors[Number(status)]
  const statusString = statuses[Number(status)]

  const style = { display: 'flex', alignItems: 'center', justifyContent: 'start' }
  const props = {
    container: {
      style,
    }
  }

  return (
    <div {...props.container}>
      <div style={style}>
        <Tag color={color}>{statusString}</Tag>
      </div>
    </div>
  )
}

export default StatusCell
